// extracted by mini-css-extract-plugin
module.exports = {"spam":"ErrorLabel_spam__22ue9"};